import { ALERT_MESSAGES } from '../enums/common'
import BLACKLIST from '../enums/blackList'

export const validateTelephone = (deafultPhoneNumber: string) => ({
  validate: (value: string) => {
    if (!value) {
      return ALERT_MESSAGES.mandatory.message
    }

    if (value && value === deafultPhoneNumber) {
      return true
    }

    if (value.length < 10) {
      return ALERT_MESSAGES.minLengthPhone.message
    }

    const pattern = /^[0-9 +-]+$/i
    if (!pattern.test(value)) {
      return ALERT_MESSAGES.patternNumberPlusMinus.message
    }

    const regex = RegExp(/^(?!0+$)[0-9+\- ]*$/i)
    const regexZeroPlusMinus = RegExp(/^(?!0+$)[0+\- ]*$/i)
    return !regex.test(value) ||
      (regexZeroPlusMinus.test(value) && !RegExp(/^[+\- ]*$/i).test(value))
      ? ALERT_MESSAGES.patternZeroOnly.message
      : true
  },
})

export const validateEmail = (
  email?: string,
  showConfirmationEmail?: boolean
) => ({
  validate: (value: string) => {
    if (email && !showConfirmationEmail) {
      return true
    }
    const emailPattern = /^([a-z0-9]{1}[a-z0-9._-]*)@([a-z0-9._-]*)\.([a-z0-9._-]*)([a-z0-9]{1})$/i
    if (!value || !emailPattern.test(value)) {
      return ALERT_MESSAGES.validEmail?.message
    }

    const [, domain] = value.split('@')

    return BLACKLIST.includes(domain)
      ? ALERT_MESSAGES.blackListDomain.message
      : true
  },
})

export const validateConfirmationEmail = (email: string) => ({
  validate: (value: string) => {
    return email?.toLowerCase() !== value?.toLowerCase()
      ? ALERT_MESSAGES.emailConfirmation.message
      : true
  },
})

export const validateFranceNumber = (value: string) => {
  const regex = RegExp(/^(0|0033|\+33)[6-7][0-9 ]*$/)

  return regex.test(value)
}

export const validateStep4FranceNumber = (value: string) => {
  const regex = RegExp(/^(0|00|0033|\+33)[6-7][0-9 ]*$/)

  return regex.test(value)
}
